<template>
  <div class="no-data">
    <img
      v-if="showImage"
      :src="smileEmptySvgUrl"
      width="64"
      height="64"
      alt="No Data Available"
      class="mb-5"
    >
    <h5 class="mb-2">
      <slot name="noData">
        No Data Available in
        <span class="document-type">
          {{ label }} {{ documentType }}
        </span>
      </slot>
    </h5>
    <p>
      <slot name="description">
        There is no
        {{ documentType === 'Requisitions' ? 'requisition' : 'post' }}
        data available for your selection.
      </slot>
    </p>
    <slot name="content" />
  </div>
</template>

<script>
import smileEmptySvg from '@/assets/smiles/smile-empty.svg';

export default {
  name: 'NoDataBlock',
  props: {
    label: {
      type: String,
      default: '',
    },
    documentType: {
      type: String,
      default: 'Posts',
    },
    showImage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    smileEmptySvgUrl() {
      return smileEmptySvg;
    },
  },
};
</script>

<style scoped lang="less">
@import '@/less/mixins';
.no-data {
  background: @white;
  border: 1px solid @stroke-default;
  padding: 24px;
  border-radius: 10px;
  text-align: center;
  color: rgba(@grey-900, .5);
  > p {
    &:last-child {
      margin: 0;
    }
  }
  &.border-bottom {
    border-bottom: 2px solid @stroke-default;
  }

  .document-type {
    color: @text-darkest;
  }
}
</style>
